import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TransactionModel } from "@/core/models/transaction.model";
import { TableRepo } from "../table.repo";

interface _TransactionGetParams {
    search?: string;
}

@injectable()
export class TransactionRepo extends TableRepo<TransactionModel> {
    constructor() {
        super("/api/Transaction");
    }

    async getData(index: number, params: _TransactionGetParams, pageSize = 10): Promise<ApiPage<TransactionModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async exportReport(params: object) {
        try {
            const response = await this.apiRepo.getBlob(`${this.basepath}/export-report`, params)
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }
}